import { api } from "@services/api";
import { type Task } from "@services/task/types";
import { type Vessel } from "./vessel/types";

export const TASK_STATUS = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
} as const;

export interface CompleteTaskByIdArgs {
  status: string;
  internalNotes?: string;
  internalNotesDocument?: string;
  internalNotesDocumentName?: string;
  externalNotes?: string;
  externalNotesDocument?: string;
  externalNotesDocumentName?: string;
}

export interface CompleteTaskByNominationIdArgs {
  decisionStatus: keyof typeof TASK_STATUS;
  noteText?: string;
  attachmentUrl?: string;
  documentName?: string;
}

export const getTaskById = async (service: string, taskId?: string) => {
  return api.get<Vessel>(service, `tasks/${taskId}`);
};

export const claimTaskByVesselId = async (
  service: string,
  vesselId: string,
  transactionId?: string,
) => {
  return api.put<Task>(
    service,
    `tasks/${vesselId}:claim`,
    ...(transactionId ? [undefined, { transactionId }] : []),
  );
};

export const unclaimTaskByVesselId = async (
  service: string,
  vesselId: string,
  transactionId?: string,
) => {
  return api.put<Task>(
    service,
    `tasks/${vesselId}:unclaim`,
    ...(transactionId ? [undefined, { transactionId }] : []),
  );
};

export const completeTaskByVesselId = async ({
  service,
  vesselId,
  params,
  transactionId,
}: {
  service: string;
  vesselId: string;
  params: CompleteTaskByIdArgs;
  transactionId?: string;
}) => {
  return api.put<Task>(
    service,
    `tasks/${vesselId}:complete`,
    { ...params },
    ...(transactionId ? [{ transactionId }] : []),
  );
};

export const claimTaskByNominationId = async (nominationId: string) => {
  return api.put<Task>("bff-vessel", `vessels/vessel-nominations/tasks/${nominationId}:claim`);
};

export const unclaimTaskByNominationId = async (nominationId: string) => {
  return api.put<Task>("bff-vessel", `vessels/vessel-nominations/tasks/${nominationId}:unclaim`);
};

export const completeTaskByNominationId = async ({
  nominationId,
  params,
}: {
  nominationId: string;
  params: CompleteTaskByNominationIdArgs;
}) => {
  return api.put<Task>("bff-vessel", `vessels/vessel-nominations/tasks/${nominationId}:complete`, {
    ...params,
  });
};
